import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';

@Injectable()
export class NotificationService {
  public url: string;

  constructor(private http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(token, task): Observable<any> {
    return this.commonRequest('notification/new', token, task);
  }

  newManual(token, task): Observable<any> {
    return this.commonRequest('notification/newmanual', token, task);
  }

  getNotification(token, id): Observable<any> {
    return this.commonRequest(`notification/detail/${id}`, token);
  }

  update(token, task, id): Observable<any> {
    return this.commonRequest(`notification/edit/${id}`, token, task);
  }

  private commonRequest(endpoint: string, token: string, task?: any): Observable<any> {
    let json = task ? JSON.stringify(task) : null;
    let params = "json=" + json + "&authorization=" + token;
    let headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest'});
    let page = 1;

    return this.http.post(`${this.url}/${endpoint}?page=${page}`, params, { headers: headers })
      .pipe(map(res => res));
  }
}
